import { Component } from "react";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import ParametroConsultaEliminadas from "../../../Contenedores/Autorizaciones/ParametroConsultaEliminadas";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import es from "date-fns/locale/es";
import ResultadoConsulta from "./ResultadoConsultaEliminadas";

registerLocale("es", es);
export default class ParametrosConsultaEliminadas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seleccionUsuarioElimino: "0",
      fechaDesde: "",
      fechaHasta: "",
      ListaUsuarioElimino: [],
      MostrarParametrosBusqueda: false,
      MostrarComponenteResultados: false,
      ResultadoConsulta: [],
    };

    this._onSeleccionUsuarioElimino =
      this._onSeleccionUsuarioElimino.bind(this);
    this._fechaDesdeSeleccionada = this._fechaDesdeSeleccionada.bind(this);
    this._fechaHastaSeleccionada = this._fechaHastaSeleccionada.bind(this);
    this._ConsulteEliminadas = this._ConsulteEliminadas.bind(this);
    this.limpiarFiltros = this.limpiarFiltros.bind(this);
  }

  async componentDidMount() {
    await this.ObtengaCombobox();
  }

  async ObtengaCombobox() {
    let Usuarios =
      await ServicioAutorizaciones.ObtengaUsuariosRolEliminarAutorizaciones();

    this.setState({
      ListaUsuarioElimino: Usuarios,
      MostrarParametrosBusqueda: true,
    });
  }

  async _onSeleccionUsuarioElimino(e) {
    this.setState({
      seleccionUsuarioElimino: e.target.value,
    });
  }

  async _fechaDesdeSeleccionada(date) {
    this.setState({
      fechaDesde: date !== null ? date : null,
    });
  }

  async _fechaHastaSeleccionada(date) {
    this.setState({
      fechaHasta: date !== null ? date : null,
    });
  }

  obtengaParametros() {
    let parametro = new ParametroConsultaEliminadas();
    parametro.FechaEliminacionDesde = this.state.fechaDesde;
    parametro.FechaEliminacionHasta = this.state.fechaHasta;
    parametro.UsuarioElimino =
      this.state.seleccionUsuarioElimino === "0"
        ? null
        : this.state.seleccionUsuarioElimino;
    return parametro;
  }

  limpiarFiltros = () => {
    this.setState({
      seleccionUsuarioElimino: "0",
      fechaDesde: "",
      fechaHasta: "",
    });
  };

  async _ConsulteEliminadas() {
    let parametro = this.obtengaParametros();
    let consulta =
      await ServicioAutorizaciones.ConsultarAutorizacionesEliminadas(parametro);

    if (consulta.esValido) {
      this.setState({
        ResultadoConsulta: consulta.autorizacionesEliminadas,
        MostrarComponenteResultados: true,
        MostrarDetalleConsulta: false,
      });
      CerrarNotificador();
    } else {
      Notificar("error", consulta.errores);
    }
  }

  render() {
    return (
      <div>
        <div className="card shadow mb-4">
          <div className="card-header">
            <h6 className="m-0 font-weight-bold text-primary">
              Filtros de Búsqueda
            </h6>
          </div>
          <div className="card-body">
            <div className="col">
              <div className="row form-inline">
                <label
                  htmlFor="FechaEliminoDesde"
                  aria_label="Eliminación Desde"
                  className="mr-sm-2"
                >
                  Eliminación Desde{" "}
                </label>
                <DatePicker
                  id="FechaEliminoDesde"
                  locale="es"
                  selected={this.state.fechaDesde}
                  onChange={this._fechaDesdeSeleccionada}
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  autoComplete="off"
                />

                <label
                  htmlFor="FechaEliminoHasta"
                  aria_label="Eliminación Hasta"
                  className="ml-sm-3 mr-sm-2"
                >
                  Eliminación Hasta
                </label>
                <DatePicker
                  id="FechaEliminoHasta"
                  locale="es"
                  selected={this.state.fechaHasta}
                  onChange={this._fechaHastaSeleccionada}
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  autoComplete="off"
                />

                <label
                  htmlFor="UsuarioElimino"
                  aria_label="Usuario que Eliminó"
                  className="ml-sm-3 mr-sm-2"
                >
                  Usuario que Eliminó
                </label>
                <select
                  id="UsuarioElimino"
                  className="form-control"
                  value={this.state.seleccionUsuarioElimino}
                  onChange={(e) => this._onSeleccionUsuarioElimino(e)}
                >
                  <option value="0">Todos</option>
                  {this.state.ListaUsuarioElimino.map((item) =>
                    item != null ? (
                      <option
                        key={item.identificacion}
                        value={item.identificacion}
                      >
                        {item?.nombrePersona}
                      </option>
                    ) : null
                  )}
                </select>
              </div>
              <br />
            </div>
            <div className="row col-sm-12">
              <button
                id="btnBuscarEliminadas"
                type="button"
                onClick={this._ConsulteEliminadas}
                className="btn btn-primary btn-icon-split cBtnBuscarRevocaciones"
              >
                <span className="icon text-white-50">
                  <i className="fas fa-search"></i>
                </span>
                <span className="text">Buscar</span>
              </button>

              <button
                id="btnLimpiarFiltros"
                onClick={this.limpiarFiltros}
                type="button"
                className="btn btn-sm btn-light ml-3"
              >
                <i className="fas fa-redo fa-sm mr-1"></i>
                Limpiar filtros
              </button>
            </div>
          </div>
        </div>

        {this.state.MostrarComponenteResultados ? (
          <ResultadoConsulta datos={this.state.ResultadoConsulta} />
        ) : null}
      </div>
    );
  }
}
